import { render } from "./VascularHeader.vue?vue&type=template&id=6ff020bf"
import script from "./VascularHeader.vue?vue&type=script&lang=js"
export * from "./VascularHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__